import Ebony91 from "../Ebony/Ebony 9.png"
import Ebony92 from "../Ebony/Ebony 9.png"

const Ebony9images =[
    Ebony91,Ebony92
]

export default Ebony9images;